import img1 from '../assets/Homepage_1/Homepage_Slider_1.jpg'
import img2 from '../assets/Homepage_1/Homepage_Slider_2.jpg'
import img3 from '../assets/Homepage_1/Homepage_Slider_3.jpg'
import img4 from '../assets/Homepage_1/Homepage_Slider_4.jpg'

export default{
  img1,
  img2,
  img3,
  img4,
}